import { environment } from './baseUrl';


export function GetWechatOpenId(code) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetWechatOpenId?code=' + code, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}
export function GetUserDtoByCode(code) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetUserDtoByCode?code=' + code, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetUserInfoByOpenId() {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetUserInfoByOpenId', {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function CreateWxConfig() {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/CreateWxConfig', {
        method: 'post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetWXJSSDK(url) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetWXJSSDK?url=' + url, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetMediaFile(mediaId, planetId) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetMediaFile?mediaId='
        + mediaId + "&planetId=" + planetId, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}





export function UpdateWechatDeathInfo(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/UpdateWechatDeathInfo', {
        method: 'put', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function CreateOrderForm(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/CreateOrderForm', {
        method: 'post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function CreateWecharOrderInfo(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/CreateWecharOrderInfo', {
        method: 'post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetJsApiPay(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/CreateJsApiPay', {
        method: 'post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function CreateOrderJsPay(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/CreateOrderJsPay', {
        method: 'post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function SaveShoppingOrder(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/SaveShoppingOrder', {
        method: 'post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}


export function GetWecharOrderInfo(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetWecharOrderInfo?id=' + id, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetWecharOrderList(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetWecharOrderList', {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetImgsByTableIdAndTableName(tableId, tableName) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetImgsByTableIdAndTableName?tableId='
        + tableId + "&tableName=" + tableName, {
            method: 'get', //改成post
            mode: 'cors', //跨域
            headers: {
                //请求头{
                Accept: 'application/json',
                // Authorization: 'Bearer ' + localStorage.getItem("auth"),
                OpenId: localStorage.getItem("openid"),
                'Content-Type': 'application/json;charset=utf-8',
            },
            // body: JSON.stringify(params), //向服务器发送的数据
        }).then(response => response.json());
}

export function SaveOrderInfoImgs(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/SaveOrderInfoImgs', {
        method: 'post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetWeChatMenu() {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetWeChatMenu', {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function UpdateOrderForm(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/UpdateOrderForm', {
        method: 'put', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetDeathListById() {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetDeathListById', {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetDeathList() {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetDeathList', {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetOrdereInfoById(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetOrdereInfoById?id=' + id, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function SaveFile(formData) {
    return fetch(environment.apiEndpoint + '/api/FileUpload/SaveFile', {
        method: 'post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            // Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            Authorization: "",
            OpenId: localStorage.getItem("openid"),
            // 'Content-Type': 'application/json;charset=utf-8',
        },
        body: formData, //向服务器发送的数据
    }).then(response => response.json());
}

export function SaveFiles(formData) {
    return fetch(environment.apiEndpoint + '/api/FileUpload/SaveFiles', {
        method: 'post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            // Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            Authorization: "",
            OpenId: localStorage.getItem("openid"),
            // 'Content-Type': 'application/json;charset=utf-8',
        },
        body: formData, //向服务器发送的数据
    }).then(response => response.json());
}

export function GetWXUserInfoByOpenId() {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetWXUserInfoByOpenId', {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            'Content-Type': 'application/json;charset=utf-8',
            OpenId: localStorage.getItem("openid"),
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function UpdateCoupletIsDown(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/UpdateCoupletIsDown?id=' + id, {
        method: 'put', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetPayOrder(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetPayOrder?id=' + id, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            'Content-Type': 'application/json;charset=utf-8',
            OpenId: localStorage.getItem("openid"),
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetProductListByMapId(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetProductListByMapId?id=' + id, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            'Content-Type': 'application/json;charset=utf-8',
            OpenId: localStorage.getItem("openid"),
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetProductTempList() {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetProductTempList', {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            'Content-Type': 'application/json;charset=utf-8',
            OpenId: localStorage.getItem("openid"),
        },
        // body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function PutProductByDeathMapId(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/PutProductByDeathMapId', {
        method: 'put', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function CreateProductDeathMaps(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/CreateProductDeathMaps', {
        method: 'post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}




export function GetDataDictionarysByCode(code) {
    return fetch(environment.apiEndpoint + '/api/services/app/Account/GetDataDictionarysByCode?Code=' + code, {
        method: 'GET', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function GetHotelByPId(parentId) {
    return fetch(environment.apiEndpoint + '/api/services/app/ProductInfo/GetHotelByPId?parentId=' + parentId, {
        method: 'GET', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: 7,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function UpdateUserInfoByOpenId(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/SaveUserByOpenId', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: 7,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetWXUserByOpenId() {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetWXUserByOpenId', {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: 7,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function SavePlanetInfo(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/SavePlanetInfo', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function SavePlanetUserMap(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/SavePlanetUserMap', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function CreateAsyncFuGaoInfo(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/CreateAsyncFuGaoInfo?id=' + params, {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetPlanets() {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetPlanets', {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function GetPlanetInfo(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetPlanetInfo?id=' + id, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function GetPlanetProductPayRecords(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetPlanetProductPayRecords?planetId=' + id, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function GetSystemMemorys(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetSystemMemorys?userId=' + id, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function PostRecordingDetails(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/PostRecordingDetails', {
        method: 'post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetGuestBooks(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/PostGuestBooks', {
        method: 'post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function SaveGuestBook(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/SaveGuestBook', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function InsertPlanetFamilyGroup(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/InsertPlanetFamilyGroup', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function SavePlanetFamilyGroup(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/SavePlanetFamilyGroup', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function SendPlanetFamilyGroup(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/SendPlanetFamilyGroup', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function PostAlbumClass(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/PostAlbumClass', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function PostAlbums(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/PostAlbums', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function SaveAlbumClass(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/SaveAlbumClass', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function SaveAlbum(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/SaveAlbum', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function SaveUserAction(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/SaveUserAction', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function PostUserAction(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/PostUserAction', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function SaveMedia(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/SaveMedia', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function PostMedias(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/PostMedias', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function CreatePublicAccountFollower(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/CreatePublicAccountFollower', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function GetGuestBook(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetGuestBook?id=' + id, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function GetAlbumsById(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetAlbumsById?id=' + id, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function GetFamilyRegistrys(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetFamilyRegistrys?id=' + id, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function GetFGFamilyRegistrys(id) {
    return fetch(environment.fgapiEndpoint + '/api/services/app/AppletsV2/GetFamilyRegistrys?id=' + id, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function GetMediasById(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetMediasById?id=' + id, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function GetPostById(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetPostById?id=' + id, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function GetNNProductsByTypeId(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetNNProductsByTypeId?typeId=' + id, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function GetNNProductInfoById(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetNNProductInfoById?id=' + id, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function GetPublicAccountFollowerByOpenId(name) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/GetPublicAccountFollowerByOpenId?name=' + name, {
        method: 'get', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function UpdateRecordingDetailById(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/UpdateRecordingDetailById?id=' + id, {
        method: 'put', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function DelRecordingDetailById(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/DelRecordingDetailById?id=' + id, {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function DelAlbumsById(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/DelAlbumsById?id=' + id, {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function DelAlbumImgById(Name) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/DelAlbumImgById?Name=' + Name, {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function DelGuestBooksById(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/DelGuestBooksById?id=' + id, {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function DelMediasById(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/DelMediasById?id=' + id, {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function DelPostById(id) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/DelPostById?id=' + id, {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
    }).then(response => response.json());
}

export function SavePostInfo(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/SavePostInfo', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function SensitiveWordsVerify(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/SensitiveWordsVerify', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function SaveRecordingDetails(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/SaveRecordingDetails', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function Posts(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/Posts', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function SavePlanetAuthInfo(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/SavePlanetAuthInfo', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function PostNNShoppingOrders(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/PostNNShoppingOrders', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function PostCarousels(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/PostCarousels', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}

export function PostUserActions(params) {
    return fetch(environment.apiEndpoint + '/api/services/app/WeChatV2/PostUserActions', {
        method: 'Post', //改成post
        mode: 'cors', //跨域
        headers: {
            //请求头{
            Accept: 'application/json',
            userid: JSON.parse(localStorage.getItem("user")).id,
            // Authorization: 'Bearer ' + localStorage.getItem("auth"),
            OpenId: localStorage.getItem("openid"),
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(params), //向服务器发送的数据
    }).then(response => response.json());
}


export function SaveNNFile(formData) {
    // 2. 调用上传接口
    return fetch(environment.apiEndpoint + '/api/FileUpload/SaveNNFile', {
        method: 'POST',
        body: formData,
        headers: {
            // userid: JSON.parse(localStorage.getItem("user")).id,
            OpenId: localStorage.getItem("openid"),
        },
    }).then((response) => response.json())
}